import { useState } from "react";
import { Avatar, Box, IconButton, Menu, Typography } from "@mui/material";
import { Logout } from "@modules/auth/components/Logout";
import { getStoredToken } from "@core/utils/auth";
import { jwtDecode } from "jwt-decode";

interface JwtPayload {
  email: string;
  name: string;
  googleId: string;
  iat: number;
  exp: number;
}

export const UserMenu = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [userName, setUserName] = useState<string>("");
  const [userInitial, setUserInitial] = useState<string>("");

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  // Get user info from token
  const token = getStoredToken();
  if (token && !userName) {
    try {
      const decoded = jwtDecode<JwtPayload>(token);
      if (decoded?.name) {
        setUserName(decoded.name);
        setUserInitial(decoded.name.charAt(0).toUpperCase());
      }
    } catch (error) {
      console.error("Error decoding token:", error);
    }
  }

  return (
    <Box>
      <IconButton
        onClick={handleMenuOpen}
        size="small"
        sx={{ p: 0 }}
        aria-controls={anchorEl ? "user-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={!!anchorEl}
      >
        <Avatar
          sx={{
            width: 32,
            height: 32,
            bgcolor: "primary.main",
            color: "primary.contrastText",
            fontSize: 14,
            fontWeight: 600,
          }}
        >
          {userInitial}
        </Avatar>
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        PaperProps={{
          elevation: 3,
          sx: {
            mt: 1.5,
            minWidth: 200,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <Box sx={{ px: 2, py: 1.5 }}>
          <Typography variant="subtitle2" noWrap>
            {userName}
          </Typography>
        </Box>
        <Logout />
      </Menu>
    </Box>
  );
};
